<div class="wrapperi">
    <div class="group-container pt-4 ps-4">
        <div class="col-12">

            <div class="pointer" (click)="goBack()">
                <p class="semiboldlinkblue16 mb-0"><img src="../../assets/icons/chevron_left.svg"
                        class="chevron-margins" />Takaisin</p>
            </div>
        </div>
        <div class="data-container" *ngIf="list && list.name">
            <p class="semiboldtextblue90024">{{list.name}}</p>
            <div class="d-flex justify-content-between">
                <div class="icon-container flex-column">
                    <div class="d-inline-flex">
                        <div class="d-inline-flex align-items-center">
                            <div class="icon-container-lists d-flex justify-content-center me-2" style="width: 20px">
                                <img src="../../assets/icons/bookmark_icon.svg" width="12" alt="">
                            </div>
                            <div class="name-container-lists">
                                <p class="normaltextgray90016 f-os mb-0"><span
                                        class="me-1">{{list.profiles.length}}</span>tallennettua profiilia</p>
                            </div>
                        </div>
                        <div class="d-flex ms-4 align-items-center">
                            <div class="icon-container-lists d-flex justify-content-center me-2" style="width: 20px">
                                <img src="../../assets/icons/calendar_dark_blue.svg" width="16" alt="">
                            </div>
                            <div class="name-container-lists">
                                <p class="normaltextgray90016 f-os mb-0">Viimeksi muokattu {{list.editedDate
                                    |formateDate}}</p>
                            </div>
                        </div>
                        <div class="d-flex ms-4 align-items-center">
                            <div class=" formed-search align-items-center d-flex" *ngIf="!shared_view;else shared_rights">
                                <div class="d-flex w-100">
                                    <div class="search-cont-icon d-flex justify-content-center align-items-center">
                                        <img src="../../assets/icons/sb_followers.svg" alt="">
                                    </div>

                                    <select (change)="saveRights()" type="text" id="sorting"
                                        placeholder="Valitse työaika" class="formed-select">
                                        <option value="false">Vain sinulla on pääsy</option>
                                        <option value="true">Kaikilla orgainsaatiossasi on pääsy</option>

                                    </select>
                                </div>
                            </div>
                            <ng-template #shared_rights>
                                <div class=" align-items-center d-flex">
                                    <div class="d-inline-flex w-100">
                                        <div class=" pe-2 d-flex justify-content-center align-items-center">
                                            <img src="../../assets/icons/sb_followers.svg" alt="">
                                        </div>
    
                                        <p class="mb-0 normaltextblue90016 f-os">Kaikilla orgainisaatiossasi on pääsy</p>
                                    </div>
                                </div>
                            </ng-template>

                        </div>
                    </div>
                    <div class="edit-section d-flex w-100 mt-2 flex-column">
                        <div class="" *ngIf="!shared_view;else no_txt">
                            <textarea class="form-control" [(ngModel)]="list.description" (change)="saveDescription()"
                            placeholder="Kuvaus"></textarea>
                        <div class="" *ngIf="is_saved">
                            <p class="normaltextblue90016 mt-2">Tallennettu <img class="ms-2"
                                    src="../../assets/icons/check_icon.svg" /></p>
                        </div>

                        </div>
                        <ng-template #no_txt>
                            <p class="mb-0 mt-3 normaltextblue90016 f-os">{{list.description}}</p>

                        </ng-template>
                    </div>

                </div>
                <div class="delete-container">
                    <div class="" *ngIf="!shared_view">
                        <button class="btn btn-formed-hollow align-items-center d-flex" data-bs-toggle="modal" data-bs-target="#remove-list-modal" ><img
                            src="../../assets/icons/trash_icon.svg" width="14" class="me-2" />Poista</button>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-between">
                <div class="">

                </div>
                <div class="">
                    <p class="normaltextblue90016 f-os">Luonut {{list.employer.firstName + ' ' +
                        list.employer.lastName}}</p>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 ps-2 pe-2 pb-4 pt-0">
        <div class="" *ngIf="list && list.profiles && list.profiles.length > 0; else no_interest_content">
            <div class="row m-0 p-0">
                <div class="col-md-4 col-lg-4 col-xl-3 mt-4" *ngFor="let opening of list.profiles">
                    <div class="" *ngIf="true;else banner_template">
                        <div class="formed-border-radius relative formed-shadow pb-4">
                            <div class="wish-top-container bg-gray">
                                <div class="p-3 d-flex justify-content-between">
                                    <div class="d-flex">
                                        <div class="new-badge" *ngIf="opening.is_new">
                                            <p class="mb-0">Uusi</p>
                                        </div>
                                    </div>
                                    <div class="d-flex white-wish-heart-box" (click)="openRemoveProfile(opening)" *ngIf="!shared_view">
                                        <img class="" width="16" src="../../assets/icons/trash_icon.svg" />
                                    </div>
                                </div>
                            </div>
                            <div class="more-z" (click)="fetchPublicProfile(opening)">
                                <div class="col-12 row m-0">
                                    <div class="boxer">
                                        <div class="transpa-bg cp">
                                            <div class="d-flex justify-content-center profile-picture-mt">
                                                <div *ngIf="opening['profilePicture'];else no_image">
                                                    <img width="120"
                                                        onerror="this.src='../../assets/icons/formed_no_profile.svg'"
                                                        class="rounded-circle" height="120"
                                                        src="{{opening['profilePicture']}}" alt="">
                                                </div>
                                                <ng-template #no_image>
                                                    <div class="">
                                                        <img class="rounded-circle"
                                                            src="../../assets/icons/formed_no_profile.svg" width="120"
                                                            alt="">
                                                    </div>
                                                </ng-template>
                                            </div>
                                            <div class="mt-2 text-center">

                                                <div class="">
                                                    <p class="semiboldtextblue90020 mb-0">{{opening.firstName}}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class=" margin-10 d-flex flex-wrap justify-content-center d-lg-block">
                                            <div class="">
                                                <div class="gb-box d-flex align-items-center" *ngIf="opening.areas && opening.areas.length > 0">
                                                    <!-- Icon Section -->
                                                    <div class="icon-container d-flex align-items-center me-2">
                                                        <img src="../../assets/icons/location_dark_blue.svg" alt="Icon">
                                                    </div>

                                                    <!-- Skills and +X Section -->
                                                    <div
                                                        class="d-flex justify-content-between flex-grow-1 align-items-center">
                                                        <!-- Skills List -->
                                                        <div class="skills-container">
                                                            <span class="normaltextblue80016 me-1 f-os"
                                                                *ngFor="let area of opening.areas; let i = index">
                                                                <span *ngIf="i < 1">
                                                                    {{ area.name_fi }}<span *ngIf="i < 1"></span>
                                                                </span>
                                                            </span>
                                                        </div>

                                                        <!-- +X Section -->
                                                        <div class="ms-2 badge-container">
                                                            <span class="text-end skill-num-tag normaltextblue60016"
                                                                *ngIf="opening.areas.length > 1">
                                                                +{{ opening.areas.length - 1 }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="gb-box d-flex align-items-center">
                                                    <!-- Icon Section -->
                                                    <div class="icon-container d-flex align-items-center me-2">
                                                        <img src="../../assets/icons/language_icon.svg" alt="Icon">
                                                    </div>

                                                    <!-- Skills and +X Section -->
                                                    <div
                                                        class="d-flex justify-content-between flex-grow-1 align-items-center">
                                                        <!-- Skills List -->
                                                        <div class="skills-container">
                                                            <span class="normaltextblue80016 me-1 f-os"
                                                                *ngFor="let lang of opening.languages; let i = index">
                                                                <span *ngIf="i < 2">
                                                                    {{ lang.name_fi }}<span *ngIf="i < 1">,</span>
                                                                </span>
                                                            </span>
                                                        </div>

                                                        <!-- +X Section -->
                                                        <div class="ms-2 badge-container">
                                                            <span class="text-end skill-num-tag normaltextblue60016"
                                                                *ngIf="opening.languages.length > 2">
                                                                +{{ opening.languages.length - 2 }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="gb-box d-flex align-items-center">
                                                    <!-- Icon Section -->
                                                    <div class="icon-container d-flex align-items-center me-2">
                                                        <img src="../../assets/icons/suitcase_icon.svg" alt="Icon">
                                                    </div>

                                                    <!-- Skills and +X Section -->
                                                    <div
                                                        class="d-flex justify-content-between flex-grow-1 align-items-center" *ngIf="opening.job_titles && opening.job_titles.length > 0;else no_job_titles">
                                                        <!-- Skills List -->
                                                         
                                                        <div class="skills-container">
                                                            <span class="normaltextblue80016 me-1 f-os"
                                                                *ngFor="let title of opening.job_titles; let i = index">
                                                                <span *ngIf="i < 2">
                                                                    {{ title.name_fi }}<span *ngIf="i < 1">,</span>
                                                                </span>
                                                            </span>
                                                        </div>

                                                        <!-- +X Section -->
                                                        <div class="ms-2 badge-container">
                                                            <span class="text-end skill-num-tag normaltextblue60016"
                                                                *ngIf="opening.job_titles.length > 2">
                                                                +{{ opening.job_titles.length - 2 }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <ng-template #no_job_titles>
                                                        <div class="skills-container">
                                                            <span class="normaltextblue80016 me-1 f-os">{{opening.mdType.name_fi}}</span>
                                                        </div>

                                                    </ng-template>
                                                </div>
                                                <div class="gb-box d-flex align-items-center" *ngIf="opening.skills && opening.skills.length > 0">
                                                    <!-- Icon Section -->
                                                    <div class="icon-container d-flex align-items-center me-2">
                                                        <img src="../../assets/icons/suitcase_icon.svg" alt="Icon">
                                                    </div>

                                                    <!-- Skills and +X Section -->
                                                    <div
                                                        class="d-flex justify-content-between flex-grow-1 align-items-center">
                                                        <!-- Skills List -->
                                                        <div class="skills-container">
                                                            <span class="normaltextblue80016 me-1 f-os"
                                                                *ngFor="let skill of opening.skills; let i = index">
                                                                <span *ngIf="i < 3">
                                                                    {{ skill.name_fi }}<span *ngIf="i < 2">,</span>
                                                                </span>
                                                            </span>
                                                        </div>

                                                        <!-- +X Section -->
                                                        <div class="ms-2 badge-container">
                                                            <span class="text-end skill-num-tag normaltextblue60016"
                                                                *ngIf="opening.skills.length > 3">
                                                                +{{ opening.skills.length - 3 }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ng-template #banner_template>
                        <div (click)="routeAd(opening)"
                            class="h-100 w-100 pointer formed-shadow relative formed-border-radius formed-shadow"
                            style="cursor: pointer;background: url({{opening.image}}); background-size: cover">
                            <div class="pointer h-100 w-100"></div>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
        <ng-template #no_interest_content>
            <div class=" mt-4 ps-2 pe-2">
                <div class="bg-f-w formed-shadow col-12 row pb-4 mb-4 m-0" *ngIf="!isLoading">
                    <div class="col-2">

                    </div>
                    <div class="col-12 col-lg-8">
                        <div class="bg-f-w p-4">
                            <div class="justify-content-center d-flex">
                                <img src="../../assets/images/no_search_found.png" height="270" alt="">
                            </div>
                            <div class="p-4">
                                <p class="semiboldtextblue24 text-center mt-4">
                                    Ei tallennettuja profiileja.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-2">

                    </div>
                </div>
            </div>


        </ng-template>
    </div>
</div>

<button id="oc-profile" class="btn btn-primary" type="button" data-bs-toggle="offcanvas"
    data-bs-target="#offcanvasRight" aria-controls="offcanvasRight" style="display: none;"></button>
<div class="offcanvas offcanvas-end oc-33" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
    <div *ngIf="opening" class="oc-content">
        <div class="oc-header">
            <div class="d-flex justify-content-between">
                <div class="d-flex">
                    <div class="d-flex align-items-center">
                        <button class="btn-close" type="button" data-bs-dismiss="offcanvas" aria-label="Close">
                            <img src="../../assets/icons/close_icon.svg" width="20" alt="">
                        </button>
                    </div>
                </div>
                <div class="d-flex">
                    <div class="white-wish-heart-box" *ngIf="!shared_view" (click)="openRemoveProfile(opening.profile)">
                        <img class="" width="14" src="../../assets/icons/trash_icon.svg" />
                    </div>
                </div>
            </div>
        </div>
        <div class="transpa-bg cp">
            <div class="d-flex justify-content-center profile-picture-mt-lg">
                <div *ngIf="opening['profile']['profilePicture'];else no_image">
                    <img width="166" onerror="this.src='../../assets/icons/formed_no_profile.svg'"
                        class="rounded-circle" height="166" src="{{opening['profile']['profilePicture']}}" alt="">
                </div>
                <ng-template #no_image>
                    <div class="">
                        <img class="rounded-circle" src="../../assets/icons/formed_no_profile.svg" width="166" alt="">
                    </div>
                </ng-template>
            </div>
            <div class="mt-2 text-center">
                <p class="semiboldtextblue90024 mb-0">{{opening.profile.firstName}}</p>

            </div>
            <div class="d-flex w-100 justify-content-center">
                <div class="">
                    <div class="text-center justify-content-center d-flex">
                        <button class="text-center btn btn-formed-main-blue mt-2 mb-3" (click)="sendMessage()"><img
                                class="me-2 neg-margin-2" width="18"
                                src="../../assets/icons/paperplane_white.svg" />Lähetä viesti</button>
                    </div>

                </div>
            </div>
            <div class="mb-3" *ngIf="contacted_by.length > 0">
                <div class="justify-content-center flex-column flex-lg-row d-lg-flex justify-content-lg-center"
                    *ngFor="let data of contacted_by">
                    <div class=" ps-4 ps-md-0 me-3">
                        <div [ngClass]="opening.can_open ? '' : ''"
                            class=" ms-3 ms-lg-0 justify-content-center align-items-center d-flex">
                            <p class="cbtext mb-0 "><img class="me-2 mb-1" width="30" height="30"
                                    src="../../assets/icons/contactedby.svg" />{{data.employer.firstName}} kontaktoinut
                            </p>
                        </div>
                    </div>

                </div>
            </div>
            <div class="bubble-box mt-20">
                <p class="gradient-text mb-0">Profiili</p>
                <div class="d-flex mt-2">
                    <div class="icon-width text-center">
                        <img src="../../assets/icons/email_icon.svg">

                    </div>
                    <div class="">
                        <p class="normaltextblue80016 mb-0 f-os ms-text-start sm-m"><strong>Sähköposti: </strong>
                            {{opening.profile.email}}</p>
                    </div>
                </div>
                <div class="d-flex mt-2">
                    <div class="icon-width text-center">
                        <img src="../../assets/icons/language_icon.svg">

                    </div>
                    <div class="">
                        <p class="normaltextblue80016 mb-0 f-os ms-text-start sm-m"><strong>Kielitaito: </strong>
                            {{opening.profile.display_lang}}</p>
                    </div>
                </div>
                <div class="d-flex mt-2">
                    <div class="icon-width text-center">
                        <img src="../../assets/icons/school_icon.svg">

                    </div>
                    <div class="">
                        <p class="normaltextblue80016 mb-0 f-os ms-text-start sm-m"><strong>Koulutus: </strong>
                            {{opening.profile.display_school}}</p>
                    </div>
                </div>
                <div class="gbb-box d-flex align-items-center" *ngIf="opening.profile.areas && opening.profile.areas.length > 0">
                    <!-- Icon Section -->
                    <div class="icon-container d-flex align-items-center me-2">
                        <img src="../../assets/icons/location_dark_blue.svg" alt="Icon">
                    </div>

                

                    <!-- Skills and +X Section -->
                    <div class="d-flex justify-content-between flex-grow-1 align-items-center">
                        <!-- Skills List -->
                        <div class="skills-container d-flex">
                            <p class="normaltextblue80016 me-1 ms-1 f-os mb-0"><strong>Sijainnit:</strong></p>
                            <span class="normaltextblue80016 me-1 f-os"
                                *ngFor="let area of opening.profile.areas; let i = index">
                                <span>
                                    {{ area.name_fi }}<span>,</span>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="mt-10">
                    <p class="gradient-text mb-0">Tietoja minusta</p>
                    <div class="mt-2">
                        <p class="normaltextblue80016 mb-0 f-os">{{opening.profile.description}}</p>
                    </div>
                </div>
                <div class="mt-10" *ngIf="opening.profile.skills && opening.profile.skills.length > 0">
                    <p class="mb-0 normaltextgray50016">Taidot & tutkinnot</p>
                    <div class="d-flex flex-wrap">
                        <div class="blue-gradient-border me-2 mt-2" *ngFor="let skill of opening.profile.skills">
                            <p class="mb-0">{{skill.name_fi}}</p>
                        </div>

                    </div>
                </div>
                <div class="mt-10" *ngIf="opening.profile.cv && opening.profile.cv.length > 0">
                    <p class="mb-0 normaltextgray50016">Työkokemus</p>
                    <div class="bg-blue100 mt-2" *ngFor="let cv of opening.profile.cv">
                        <p class="mb-0 semiboldtextblue90016">{{cv.position}}</p>
                        <p class="mb-0 normaltextgray40014">{{cv.company}}</p>
                        <p class="d-flex normaltextblue60016 mb-0">
                            <span>{{cv.startDate.month.id}}.{{cv.startDate.year}}</span>-<span>{{cv.endDate != "" ?
                                cv.endDate.month.id + '.' + cv.endDate.year : ""}}</span>
                        </p>
                        <p class="mt-1 normaltextblue80016 mb-0">{{cv.description}}</p>
                    </div>


                </div>
                <div class="mt-10" *ngIf="opening.profile.job_titles && opening.profile.job_titles.length > 0">
                    <p class="mb-0 normaltextgray50016">Kiinnostunut näistä työnimikkeistä</p>
                    <div class="d-flex flex-wrap">
                        <div class="gray-border me-2 mt-2" *ngFor="let title of opening.profile.job_titles">
                            <p class="mb-0">{{title.name_fi}}</p>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<!-- Modal Check before deleting offer -->
<button data-bs-toggle="modal" id="remove-profile" data-bs-target="#remove-profile-modal" style="display:none"></button>
<div class="modal fade" id="remove-profile-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="">
                <div class="ps-3 pe-4 pt-4 d-flex justify-content-between">
                    <div class="">
                        <div class="d-inline-flex">
                            <div class="ms-3 ">
                                <h5 class="semiboldtextblue90024" id="exampleModalLabel">Poista profiili listasta</h5>
                            </div>
                        </div>
                    </div>
                    <div class="flex-end">
                        <button id="close-list-created" type="button" class="btn-close close-icon"
                            data-bs-dismiss="modal" aria-label="Close">
                            <img src="../../assets/icons/close_icon.svg" width="15" alt="">
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-body" *ngIf="storable_profile">
                <p class="normaltextblue90016 f-os ms-3 mb-4">Oletko varma, että haluat poistaa profiilin listastasi?
                </p>
                <div class="d-flex justify-content-center">
                    <div
                        class="max-w-70-pre formed-border-radius relative text-center align-self-center formed-shadow pb-4">
                        <div class="wish-top-container bg-gray">
                            <div class="p-3 d-flex justify-content-between">


                            </div>
                        </div>
                        <div class="more-z">
                            <div class="col-12 row m-0">
                                <div class="boxer">
                                    <div class="transpa-bg cp">
                                        <div class="d-flex justify-content-center profile-picture-mt">
                                            <div *ngIf="this.storable_profile['profilePicture'];else no_image">
                                                <img width="120"
                                                    onerror="this.src='../../assets/icons/formed_no_profile.svg'"
                                                    class="rounded-circle" height="120"
                                                    src="{{this.storable_profile['profilePicture']}}" alt="">
                                            </div>
                                            <ng-template #no_image>
                                                <div class="">
                                                    <img class="rounded-circle"
                                                        src="../../assets/icons/formed_no_profile.svg" width="120"
                                                        alt="">
                                                </div>
                                            </ng-template>
                                        </div>
                                        <div class="mt-2 text-center">

                                            <div class="">
                                                <p class="semiboldtextblue90020 mb-0">
                                                    {{this.storable_profile.firstName}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class=" margin-10 d-flex flex-wrap justify-content-center d-lg-block">
                                        <div class="">
                                            <div class="gb-box d-flex align-items-center" *ngIf="this.storable_profile.areas && this.storable_profile.areas.length > 0">
                                                <!-- Icon Section -->
                                                <div class="icon-container d-flex align-items-center me-2">
                                                    <img src="../../assets/icons/location_dark_blue.svg" alt="Icon">
                                                </div>

                                                <!-- Skills and +X Section -->
                                                <div
                                                    class="d-flex justify-content-between flex-grow-1 align-items-center">
                                                    <!-- Skills List -->
                                                    <div class="skills-container">
                                                        <span class="normaltextblue80016 me-1 f-os"
                                                            *ngFor="let area of this.storable_profile.areas; let i = index">
                                                            <span *ngIf="i < 1">
                                                                {{ area.name_fi }}<span *ngIf="i < 1"></span>
                                                            </span>
                                                        </span>
                                                    </div>

                                                    <!-- +X Section -->
                                                    <div class="ms-2 badge-container">
                                                        <span class="text-end skill-num-tag normaltextblue60016"
                                                            *ngIf="this.storable_profile.areas.length > 1">
                                                            +{{ this.storable_profile.areas.length - 1 }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="gb-box d-flex align-items-center">
                                                <!-- Icon Section -->
                                                <div class="icon-container d-flex align-items-center me-2">
                                                    <img src="../../assets/icons/language_icon.svg" alt="Icon">
                                                </div>

                                                <!-- Skills and +X Section -->
                                                <div
                                                    class="d-flex justify-content-between flex-grow-1 align-items-center">
                                                    <!-- Skills List -->
                                                    <div class="skills-container">
                                                        <span class="normaltextblue80016 me-1 f-os"
                                                            *ngFor="let lang of this.storable_profile.languages; let i = index">
                                                            <span *ngIf="i < 2">
                                                                {{ lang.name_fi }}<span *ngIf="i < 1">,</span>
                                                            </span>
                                                        </span>
                                                    </div>

                                                    <!-- +X Section -->
                                                    <div class="ms-2 badge-container">
                                                        <span class="text-end skill-num-tag normaltextblue60016"
                                                            *ngIf="this.storable_profile.languages.length > 2">
                                                            +{{ this.storable_profile.languages.length - 2 }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="gb-box d-flex align-items-center" *ngIf="this.storable_profile.skills && this.storable_profile.skills.length > 0">
                                                <!-- Icon Section -->
                                                <div class="icon-container d-flex align-items-center me-2">
                                                    <img src="../../assets/icons/suitcase_icon.svg" alt="Icon">
                                                </div>

                                                <!-- Skills and +X Section -->
                                                <div
                                                    class="d-flex justify-content-between flex-grow-1 align-items-center">
                                                    <!-- Skills List -->
                                                    <div class="skills-container">
                                                        <span class="normaltextblue80016 me-1 f-os"
                                                            *ngFor="let skill of this.storable_profile.skills; let i = index">
                                                            <span *ngIf="i < 3">
                                                                {{ skill.name_fi }}<span *ngIf="i < 2">,</span>
                                                            </span>
                                                        </span>
                                                    </div>

                                                    <!-- +X Section -->
                                                    <div class="ms-2 badge-container">
                                                        <span class="text-end skill-num-tag normaltextblue60016"
                                                            *ngIf="this.storable_profile.skills.length > 3">
                                                            +{{ this.storable_profile.skills.length - 3 }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="gb-box d-flex align-items-center">
                                                <!-- Icon Section -->
                                                <div class="icon-container d-flex align-items-center me-2">
                                                    <img src="../../assets/icons/suitcase_icon.svg" alt="Icon">
                                                </div>

                                                <!-- Skills and +X Section -->
                                                <div
                                                    class="d-flex justify-content-between flex-grow-1 align-items-center" *ngIf="this.storable_profile.job_titles && this.storable_profile.job_titles.length > 0;else no_job_titles2">
                                                    <!-- Skills List -->
                                                    <div class="skills-container">
                                                        <span class="normaltextblue80016 me-1 f-os"
                                                            *ngFor="let title of this.storable_profile.job_titles; let i = index">
                                                            <span *ngIf="i < 2">
                                                                {{ title.name_fi }}<span *ngIf="i < 1">,</span>
                                                            </span>
                                                        </span>
                                                    </div>

                                                    <!-- +X Section -->
                                                    <div class="ms-2 badge-container">
                                                        <span class="text-end skill-num-tag normaltextblue60016"
                                                            *ngIf="this.storable_profile.job_titles.length > 2">
                                                            +{{ this.storable_profile.job_titles.length - 2 }}
                                                        </span>
                                                    </div>
                                                </div>
                                                <ng-template #no_job_titles2>
                                                    <div class="skills-container">
                                                        <span class="normaltextblue80016 me-1 f-os">{{this.storable_profile.mdType.name_fi}}</span>
                                                    </div>

                                                </ng-template>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 row mt-4 ps-3">
                    <div class="col-6 d-flex">
                        <button data-bs-dismiss="modal" id="close-remove-profile"
                            class="w-100 btn btn-formed-hollow">Peruuta</button>
                    </div>
                    <div class="col-6 d-flex">
                        <button class="w-100 btn btn-formed-main-blue" (click)="removeItemFromList()">Kyllä,
                            poista</button>
                    </div>
                </div>



            </div>
        </div>
    </div>
</div>

<!-- Modal Check before deleting offer -->
<button data-bs-toggle="modal" id="remove-list" data-bs-target="#remove-list-modal" style="display:none"></button>
<div class="modal fade" id="remove-list-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="">
                <div class="ps-3 pe-4 pt-4 d-flex justify-content-between">
                    <div class="">
                        <div class="d-inline-flex">
                            <div class="ms-3 ">
                                <h5 class="semiboldtextblue90024" id="exampleModalLabel">Poista profiili listasta</h5>
                            </div>
                        </div>
                    </div>
                    <div class="flex-end">
                        <button id="close-list-created" type="button" class="btn-close close-icon"
                            data-bs-dismiss="modal" aria-label="Close">
                            <img src="../../assets/icons/close_icon.svg" width="15" alt="">
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-body" >
                <p class="normaltextblue90016 f-os ms-3 mb-4">Oletko varma, että haluat poistaa koko listan
                </p>

                <div class="col-12 row mt-4 ps-3">
                    <div class="col-6 d-flex">
                        <button data-bs-dismiss="modal" id="close-remove-list"
                            class="w-100 btn btn-formed-hollow">Peruuta</button>
                    </div>
                    <div class="col-6 d-flex">
                        <button class="w-100 btn btn-formed-main-blue" (click)="removeList()">Kyllä,
                            poista</button>
                    </div>
                </div>



            </div>
        </div>
    </div>
</div>

<!-- Modal Check before deleting offer -->
<button data-bs-toggle="modal" id="remove-profile-confirmation" data-bs-target="#remove-profile-confirmation-modal" style="display:none"></button>
<div class="modal fade" id="remove-profile-confirmation-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="">
                <div class="ps-4 pe-4 pt-4 d-flex justify-content-between">
                    <div class="">
                        <div class="d-inline-flex">
                            <div class="icon-cont">
                                <img src="../../assets/icons/check_icon_filled.svg" width="25" alt="">
                            </div>
                            <div class="ms-3 ">
                                <h5 class="semiboldtextblue90024" id="exampleModalLabel">Profiili poistettu</h5>
                            </div>
                        </div>
                    </div>
                    <div class="flex-end">
                        <button id="close-list-created" type="button" class="btn-close" data-bs-dismiss="modal"
                            aria-label="Close">
                            <img src="../../assets/icons/close_icon.svg" width="15" alt="">
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-body">
                <p class="normaltextblue90016 f-os">Voit lisätä profiilin takaisin listaan milloin vain.</p>

                <div class="col 12 row m-0 mt-20">
                    <div class="">
                        <button class="btn btn-formed-main-blue w-100" data-bs-dismiss="modal">Selvä</button>
                    </div>
                </div>


            </div>
        </div>
    </div>
</div>

<!-- Modal Check before deleting offer -->
<button data-bs-toggle="modal" id="list-removed" data-bs-target="#list-removed-modal" style="display:none"></button>
<div class="modal fade" id="list-removed-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="">
                <div class="ps-4 pe-4 pt-4 d-flex justify-content-between">
                    <div class="">
                        <div class="d-inline-flex">
                            <div class="icon-cont">
                                <img src="../../assets/icons/check_icon_filled.svg" width="25" alt="">
                            </div>
                            <div class="ms-3 ">
                                <h5 class="semiboldtextblue90024" id="exampleModalLabel">Lista poistettu</h5>
                            </div>
                        </div>
                    </div>
                    <div class="flex-end">
                        <button id="close-list-created" type="button" class="btn-close" data-bs-dismiss="modal"
                            aria-label="Close">
                            <img src="../../assets/icons/close_icon.svg" width="15" alt="">
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-body">
                <p class="normaltextblue90016 f-os">Voit luoda uuden listan milloin vain.</p>

                <div class="col 12 row m-0 mt-20">
                    <div class="">
                        <button class="btn btn-formed-main-blue w-100" data-bs-dismiss="modal">Selvä</button>
                    </div>
                </div>


            </div>
        </div>
    </div>
</div>